import {useParams} from 'react-router-dom'
import cn from 'clsx'
import {Space} from 'antd'

import styles from './RequestStatusPanel.module.scss'
import useStore from 'base/store'
import {
  Block,
  Text,
  Tag,
  CheckCircleSecondIcon,
  UserAvatar,
} from 'common/components'
import CoordinatorCheckActions from './CoordinatorCheckActions'
import ManagerCheckActions from './ManagerCheckActions'
import ControllerCheckActions from './ControllerCheckActions'
import DirectorCheckActions from './DirectorCheckActions'
import SignContractCheckActions from './SignContractCheckActions'
import AMLCheckActions from './AMLCheckActions'
import RequestOpenActions from './RequestOpenActions'
import DeclinedRequestActions from './DeclinedRequestActions'
import {
  useGetRequest,
  REQUEST_STATUS_NAME,
  REQUEST_APPROVED_STATUSES,
  RequestStatus,
} from '..'

export default function RequestStatusPanel() {
  const params = useParams()
  const role = useStore((state) => state.role)
  const {data: request, isRefetching} = useGetRequest(params.uuid)

  const statusSteps = new Array(requestStatusOrder[request.status] - 1).fill(
    null
  )

  const CheckActionsComponent = CheckActionsStatusComponent[request.status]

  const color =
    request.status === 'declined'
      ? 'red'
      : REQUEST_APPROVED_STATUSES.includes(request.status)
      ? 'green'
      : 'turquoize'

  const pushBackReason =
    request.status === 'lending-manager-check' &&
    request.statusHistory.find(
      (item: any) => item.status === 'lending-manager-check'
    )

  return (
    <Block className={cn(styles.root, styles[`root_${color}`])} type={color}>
      {Boolean(pushBackReason.reason) && (
        <PushBackReason reason={pushBackReason} />
      )}
      <div className={styles.content}>
        <Space size={24}>
          <Text weight="demiBold">Status</Text>
          <div className={styles.history}>
            {statusSteps.map((_: any, index: number) => (
              <div key={index} className={styles.step}>
                <CheckCircleSecondIcon className={styles.icon} />
              </div>
            ))}
            <Tag
              className={cn(styles.tag, statusSteps.length && styles.tag_shift)}
              color={color}
              icon={request.status === 'declined' ? 'closeLarge' : 'checkLarge'}
            >
              {REQUEST_STATUS_NAME[request.status as RequestStatus]}
            </Tag>
          </div>
        </Space>
        <CheckActionsComponent
          role={role}
          request={request}
          isRequestLoading={isRefetching}
        />
      </div>
    </Block>
  )
}

const PushBackReason = ({reason}: any) => {
  const {user} = reason

  return (
    <div className={styles.reasonPanel}>
      <Space size={10}>
        <UserAvatar size={26} src={user?.photo} alt={user?.firstName} />
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Push back reason:
          </Text>{' '}
          {reason.reason}
        </Text>
      </Space>
    </div>
  )
}

const CheckActionsStatusComponent: any = {
  'loans-coordinator-check': CoordinatorCheckActions,
  'lending-manager-check': ManagerCheckActions,
  'financial-controller-check': ControllerCheckActions,
  'director-check': DirectorCheckActions,
  approved: SignContractCheckActions,
  'aml-check': AMLCheckActions,
  'ready-to-open': RequestOpenActions,
  declined: DeclinedRequestActions,
}

const requestStatusOrder: any = {
  'loans-coordinator-check': 1,
  'lending-manager-check': 2,
  'financial-controller-check': 3,
  'director-check': 4,
  approved: 5,
  'aml-check': 6,
  'ready-to-open': 7,
  declined: 8,
}
